import { EssenceItemDto } from '@eurogast/hub-client-typescript';

export abstract class EssenceDeserializer {
  public static parseEssences(source: string): EssenceItemDto[] {

    if (!source) {
      return [];
    }

    const parts = source.split(';;');
    if (parts.length < 1) {
      throw Error(`Invalid essence format: ${source}`);
    }
    const result: EssenceItemDto[] = [];
    parts.forEach((x) => {
      const props = x.split('::');
      if (props.length !== 3) {
        throw Error(`Invalid essence format: ${source}`);
      }
      result.push({
        customerId: '',
        tenant: '',
        sku: '',
        isRelevant: true,
        date: props[0],
        quantity: Number.parseFloat(props[1]),
        smallestUnit: props[2]
      });
    });

    return result;
  }
}
